import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Utility function to create auth config
const createAuthConfig = () => ({
  headers: {
    Authorization: `Bearer ${localStorage.getItem("token")}`,
    "Content-Type": "application/json"
  }
});

// Utility function to handle error responses
const handleApiError = (error, defaultMessage) => {
  const errorMessage = error.response?.data?.payload ||
                      error.response?.data?.errorResponse?.errorMessage ||
                      error.response?.data?.response_message ||
                      error.response?.data?.message ||
                      defaultMessage;
  return {
    status: "error",
    message: errorMessage
  };
};

// Add practitioner async thunk
export const addPractitioner = createAsyncThunk(
  "practitioner/addPractitioner",
  async (practitionerData, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${API_BASE_URL}/counsellor`,
        practitionerData,
        createAuthConfig()
      );

      return {
        status: "success",
        message: "Practitioner added successfully",
        data: response.data
      };
    } catch (error) {
      return rejectWithValue(handleApiError(error, "Failed to add practitioner"));
    }
  }
);

const addPractitionerSlice = createSlice({
  name: "addPractitioner",
  initialState: {
    data: null,
    loading: false,
    error: null,
    success: false
  },
  reducers: {
    resetAddPractitioner: (state) => {
      state.data = null;
      state.loading = false;
      state.error = null;
      state.success = false;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(addPractitioner.pending, (state) => {
        state.loading = true;
        state.error = null;
        state.success = false;
      })
      .addCase(addPractitioner.fulfilled, (state, action) => {
        state.loading = false;
        if (action.payload.status === "success") {
          state.data = action.payload.data;
          state.success = true;
        } else {
          state.error = action.payload.message;
        }
      })
      .addCase(addPractitioner.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to add practitioner";
        state.success = false;
      });
  },
});

export const { resetAddPractitioner } = addPractitionerSlice.actions;
export default addPractitionerSlice.reducer;